import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-67a58d9c"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode(" 클럽딜 더보기 ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ag_text_s = _resolveComponent("ag-text-s")!
  const _component_ag_box_s = _resolveComponent("ag-box-s")!
  const _component_ag_header = _resolveComponent("ag-header")!
  const _component_group_buy = _resolveComponent("group-buy")!
  const _component_ag_content = _resolveComponent("ag-content")!
  const _component_ag_modal = _resolveComponent("ag-modal")!

  return (_openBlock(), _createBlock(_component_ag_modal, {
    "model-value": _ctx.modelValue,
    height: "calc(100% - 50px)",
    "safe-area": true,
    "swipe-to-close": true,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:modelValue', $event)))
  }, {
    default: _withCtx(() => [
      _createVNode(_component_ag_header, {
        handle: true,
        css: {backgroundColor:'#F7F8FB'}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_ag_box_s, { css: {color: 'font', dp: 'flex', mx: 20, minHeight: 40, borderBottom: '1px solid #EEF1F7'} }, {
            default: _withCtx(() => [
              _createVNode(_component_ag_text_s, { css: {grow: 1, typography: 'main16r'} }, {
                default: _withCtx(() => [
                  _hoisted_1
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ag_content, null, {
        default: _withCtx(() => [
          _createVNode(_component_group_buy, { parent: "clubdeal-all-modal" })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["model-value"]))
}